enum QRAuthAppPaths {
  Login = '/',
  NotFound = '/*',
}

export default QRAuthAppPaths;
